//**************************************************************
import {  Component, 
          OnInit, 
          Inject,
          ViewChild,
          ElementRef,
          LOCALE_ID,
          ChangeDetectorRef
        }                                     from '@angular/core';

import  {
          formatCurrency
        }                                     from '@angular/common';

import {  FormBuilder, 
          NgForm }                            from "@angular/forms";


//**************************************************************
// Firestore 
import { firestorecontrol }                   from "../../appfirestore/app.firestore"
//**************************************************************
import { MAT_DIALOG_DATA, MatDialogRef }      from '@angular/material/dialog';
import { ConfirmationStripeModal }            from './stripepaymentmodal';
//**************************************************************
// HTTP
import {  HttpClient,
          HttpHeaders,
          HttpResponse }                      from '@angular/common/http';
//**************************************************************  
import {  StripeService }                     from 'ngx-stripe';

import {  
          StripeElementsOptions,
          PaymentIntent
        }                                     from '@stripe/stripe-js';
//**************************************************************
// Application Functions
import { appfunctions  }                      from '../../functions/app.functions';
import { StripeBank } from 'stripe-angular';
//**************************************************************

@Component(
              {
                selector: 'app-comstripepayment',
                templateUrl: './comstripepayment.component.html',
                styleUrls: ['./comstripepayment.component.css']
              }             
          )

export class ComstripepaymentComponent implements OnInit 
{
  //**************************************************************
  title: string;
  message: string;
  description: string;

  stripekey: string;
  stripepay: number;
  servicecharge: number;

  // Stripe Card Details
  intentstatus: string = '';
  card: any;
  cardname: string = '';
  cardnumber: any;
  cardexpiry: any;
  cardcvc: any;

  btndisabled: boolean = false;
  loadIndicatorVisible:boolean = false;
  cardstatus: any;
  btnpaytext: string = '';

  // Stripe Details
  closestatus: boolean;
  paymentType: Number;
  eventname: string;

  seleventid:           string = '';
  selnewevent:          string = '';
  selpassword:          string = '';
  selpaymentid:         string = '';
  selpaymentstatus:     string = '';
  selpaymentidstripe:   string = '';
  successORFail: number;


  // Stripe Dummy Card Number use for testing
  // = 4242 4242 4242 4242

  // Email Validation
  email: string = '';
  emailPattern: any = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
  
  // Toast Switches
  toastVisible: boolean       = false;
  toastFileMessage: string    = '';
  toasttypeerror: string      = 'error';
  toastdisplaytime: number    = 3000;
  toastwidth: string          = '240'; 
  //**************************************************************
  // Stripe Credit Card Payments Configuration
  @ViewChild('f') f: NgForm;

  @ViewChild('stripeCard') set content( content: ElementRef) 
    {
      
      if( content )
        {
         // console.log('sssssss')
          //**************************************************************  
          var stripe = this.stripeapi.getInstance();

          var elementClasses = 
          {
            focus:    'focus',
            empty:    'empty',
            invalid:  'invalid'
          };
          //**************************************************************
          const stylecard = 
            {
              base: {
                      color: '#fff',
                      //color: '#2a2a2a',
                      fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',
                      fontSmoothing: 'antialiased',
                      fontSize: '16px',
                      fontWeight: '700',

                      ':focus': 
                        {
                          color: '#FFFFFF'
                        },

                      '::placeholder': 
                        {
                          color: '#FFFFFF'
                          //color: '#9BACC8'
                        },
                    
                      ':focus::placeholder': 
                        {
                          color: '#CFD7DF',
                        },
                    },
                      invalid: 
                        {
                          color: '#fff',
                          ':focus': 
                            {
                              color: '#FA755A',
                            },

                          '::placeholder': 
                            {
                              color: '#FFCCA5',
                            },
                        },
              };
            //**************************************************************
            // Stripe Card Elements
            // 1. Card Number
            // 2. Card Expiry MM/YY
            // 3. Card CVC 
            var elements = stripe.elements();
            //************************************************************** 
            // Cardnumber
            this.cardnumber = elements.create('cardNumber', 
                                                            {
                                                              classes: elementClasses,
                                                              showIcon: true,
                                                              iconStyle: 'solid',
                                                              style: stylecard,
                                                            }
                                              );

            this.cardnumber.mount('#cardelement-cardnumber');

            this.cardnumber.addEventListener('change', function(event) 
                      { 
                          var displayError = document.getElementById('card-errors');
                          if (event.error) 
                            {
                              document.getElementById("cardstatus").innerHTML = "InValid";
                              displayError.textContent  = event.error.message;
                            } 
                          else 
                            {
                              document.getElementById("cardstatus").innerHTML = "Valid";
                              displayError.textContent  = '';
                            }
                        }          
                  );
            //**************************************************************
            // Card Expiry Date
            this.cardexpiry  = elements.create( 'cardExpiry', 
                                                {
                                                  classes: elementClasses,
                                                  style: stylecard,
                                                }
                                              );

            this.cardexpiry.addEventListener('change', function(event) 
              {
                  var displayError = document.getElementById('card-errors');
                  if (event.error) 
                    {
                      document.getElementById("mmyystatus").innerHTML = "InValid";
                      displayError.textContent = event.error.message;
                    } 
                  else 
                    {
                      document.getElementById("mmyystatus").innerHTML = "Valid";
                      displayError.textContent = '';
                    }
                }          
              );

            this.cardexpiry.mount('#cardelement-cardexpiry');
            //**************************************************************
            // Card cvc number
            this.cardcvc = elements.create('cardCvc', 
                                          {
                                            classes: elementClasses,
                                            style: stylecard, 
                                          }
                                        );
            this.cardcvc.mount('#cardelement-cardcvc');
            
            // Card CVC number
            this.cardcvc.addEventListener('change', function(event) 
                                            {
                                                var displayError = document.getElementById('card-errors');
                                                if (event.error) 
                                                  {
                                                    document.getElementById("cvcstatus").innerHTML = "InValid";
                                                    displayError.textContent = event.error.message;
                                                  } 
                                                else 
                                                  {
                                                    document.getElementById("cvcstatus").innerHTML = "Valid";
                                                    displayError.textContent = '';
                                                  }
                                              }          
                                            ); 
            //**************************************************************
        }
    }

    // Stripe Card Configuration
  //  cardOptions: StripeElementsOptions = {
  //    style: {
  //      base: {
  //        iconColor: '#666EE8',
  //        color: '#31325F',
  //        fontWeight: '300',
  //        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
  //        fontSize: '18px',
  //        '::placeholder': 
  //            {
  //              color: '#CFD7E0'
  //            },
        
  //      },
   //     invalid:  {
   //                 iconColor: '#ffc7ee',
   //                 color: '#ffc7ee'
   //               }
   //   }
   // };


  elementsOptions: StripeElementsOptions = 
    {
      locale: 'en'
    };

  model: any = {};
  //**************************************************************
  constructor 
    ( 

      private firestoredata: firestorecontrol,

      private stripeapi: StripeService, 

      private http: HttpClient,

      private appfunction: appfunctions,
      
      private dialogRef:  MatDialogRef<ComstripepaymentComponent>,

      @Inject( MAT_DIALOG_DATA ) public data: ConfirmationStripeModal,

      @Inject(LOCALE_ID) public locale: string,

    )     
      { 
        // Default Values on Initialization
        this.closestatus    = data.closestatus          // False
        this.paymentType    = data.paymentType          // 1
        this.stripepay      = data.paymentamt;          // Event Planner Cost
        this.servicecharge  = data.serviceperc;         // 1
        this.eventname      = data.eventname;           // Event Name
        this.email          = data.customeremail;       // Email
        this.selpassword    = data.customerpassword;    // Password
        this.seleventid     = data.eventid;             // TBC

        console.log(  this.closestatus + '#' + this.paymentType + '#' + this.stripepay + '#' +
                      this.servicecharge + '#' + this.eventname + '#' +  this.email + '#' + this.selpassword + '#' +
                      this.seleventid )
      }
  //**************************************************************
  ngOnInit(): void 
    {
      // Stripe Card Elements - set status
      document.getElementById("cardstatus").innerHTML = "InValid";
      document.getElementById("mmyystatus").innerHTML = "InValid";
      document.getElementById("cvcstatus").innerHTML  = "InValid";

      switch (  this.paymentType )
        {
          case 1: // Register Event 
              {
                this.btnpaytext = 'Event Payment ' + formatCurrency(this.stripepay, this.locale, 'AUD $ ', 'AUD' );
                break;
              }

          case 5: // Spare
              {
                // this.btnpaytext = 'Register Payment ' + formatCurrency(this.stripepay, this.locale, 'AUD $ ', 'AUD' );
                break;
              }

        }

      
    }
  //**************************************************************
  async createStripePay( event: any, whatoption: number  )  
    {
      
      this.loadIndicatorVisible = false;

      if ( whatoption == 1 ) // Confirm Payment=1 # Cancel Payment -1
        {
          //**************************************************************
          // Card Number Status
          let cardvalidate =  document.getElementById("cardstatus").innerHTML.toUpperCase();
        
          let cardmmyystatus =  document.getElementById("mmyystatus").innerHTML.toUpperCase();
          
          let cardcvcstatus =  document.getElementById("cvcstatus").innerHTML.toUpperCase();
          //**************************************************************
          let result = event.validationGroup.validate();
            
          if  ( ( result.isValid                ) &&  // Devextreme Input Card Name & Email Address
                ( cardvalidate    == "VALID"    ) &&  // Stripe Card No
                ( cardmmyystatus  == "VALID"    ) &&  // Stripe Card MM/YY
                ( cardcvcstatus   == "VALID"    )     // Stripe CVC 
              )
                {
                 
                  this.loadIndicatorVisible = true;

                  var stripeamount: number;
                  stripeamount = ( this.stripepay * 100 );  

                  // Get Stripe Token
                  return (await this.createPaymentIntent( stripeamount )).subscribe( ( response ) =>
                                                                                        {
                                                                                          // console.log( response)
                                                                                          // Stripe PaymentIntent
                                                                                          this.intentstatus  = response.client_secret;

                                                                                          // Process Stripe Payment with Firebase 
                                                                                          this.processstripecharge  (   this.intentstatus,
                                                                                                                        this.cardname,
                                                                                                                        this.email,
                                                                                                                        this.eventname
                                                                                                                    )
                                                                                        }

                                                                                  )

            }
          else  
            {
              this.toastFileMessage = 'Credit Card Details Incomplete. Please recheck.....';
              this.toasttypeerror   = 'error';
              this.toastdisplaytime = 5000;
              this.toastwidth       = '250';
              this.toastVisible     = true;
            }
        }
      else
        {

          this.toastVisible     = true;
          this.toastFileMessage = 'Credit Card Payment Cancelled.....';
          this.toasttypeerror   = 'error';
          this.toastdisplaytime = 5000;
          this.toastwidth       = '250';

          setTimeout( () => {
                              this.data.closestatus = false;
                              this.dialogRef.close( this.data );
                            },
                            3000
                    )
         
        }

      return 0

    }
  //**************************************************************  
  processstripecharge( stripesecret: string, selcardname: string, selcardemail: string, selcarddetail: string )
    {

      // Error in Stripe - PaymentIntent
      if ( stripesecret == 'error')                                                      
        {

          this.toastVisible     = true;
          this.toastFileMessage = 'Error in Processing Payment with Payment Provider....';
          this.toasttypeerror   = 'error';
          this.toastdisplaytime = 5000;
          this.toastwidth       = '250';
      
          setTimeout( () => {
                              this.data.closestatus = false;
                              this.dialogRef.close( this.data );
                            },
                            5000
                    )

        }
      else
        {
          this.loadIndicatorVisible = true;

          // Stripe Payment Request
          this.stripeapi.confirmCardPayment( stripesecret, // stripe paymentintent
                                                {
                                                  payment_method: {
                                                                    card: this.cardnumber,
                                                                    billing_details: {
                                                                                        email: selcardemail,
                                                                                        name: selcardname
                                                                                      },
                                                                  },
                                                }
                                          ).subscribe( (result) => 
                                                        {
                                                            if (result.error) 
                                                              {
                                                                // Show error to your customer (e.g., insufficient funds)
                                                                this.toastVisible         = true;
                                                                this.toastFileMessage     = 'Error in Processing Payment with Payment Provider....';
                                                                this.toasttypeerror       = 'error';
                                                                this.toastdisplaytime     = 5000;
                                                                this.toastwidth           = '250';

                                                                this.loadIndicatorVisible = false;
                                                            
                                                                setTimeout( () => {
                                                                                    this.data.closestatus = false;
                                                                                    this.dialogRef.close( this.data );
                                                                                  },
                                                                                  5000
                                                                          )

                                                              } 
                                                            else 
                                                              {
                                                                // Payment Processed Successfully
                                                                //**************************************************************
                                                                if ( result.paymentIntent.status === 'succeeded' ) 
                                                                  {

                                                                    // console.log( result )
                                                                    // Process Payment Details
                                                                    switch ( this.paymentType  )
                                                                      {
                                                                        //**************************************************************
                                                                          case 1: // Registration of Event to Firebase
                                                                              {
                                                                                //**************************************************************
                                                                                // Stripe Details
                                                                                this.selpaymentstatus     = result.paymentIntent.status;
                                                                                this.selpaymentidstripe   = result.paymentIntent.id;
                                                                                // Create New EventID
                                                                                this.selnewevent          = this.appfunction.createuniqueid( 10 )

                                                                                //  console.log( this.email )
                                                                                //  console.log( this.selnewevent )
                                                                                //  console.log( this.eventname )
                                                                                //  console.log( this.selpassword )
                                                                                //  console.log(  this.selpaymentstatus  )
                                                                                //  console.log(  this.selpaymentidstripe )
                                                                              
                                                                                // Set up for a New Event Registration
                                                                                this.firestoredata.addNewEvent(   
                                                                                                                this.selnewevent,
                                                                                                                this.eventname,
                                                                                                                this.email,
                                                                                                                this.selpassword,   
                                                                                                                true,
                                                                                                                this.selpaymentidstripe                                                  
                                                                                                                ).then( data => {      
                                                                                                                                    this.successORFail = data   // data = Firestore Add Status Flag

                                                                                                                                    this.loadIndicatorVisible = false;
                                                                                                                                    this.toastVisible         = false;
                                                                                                                                  
                                                                                                                                    this.toastdisplaytime     = 5000;
                                                                                                                                    this.toastwidth           = '300';

                                                                                                                                    switch ( this.successORFail )
                                                                                                                                      {
                                                                                                                                        // Fail
                                                                                                                                        case 0: {
                                                                                                                                                    this.toastFileMessage     = 'Event not registered';
                                                                                                                                                    this.toasttypeerror       = 'error';
                                                                                                                                                    this.toastVisible         = true;

                                                                                                                                                    // Might need assess impact when
                                                                                                                                                    // a: Stripe Payment is successful but
                                                                                                                                                    // b: Firebase is not added for the event


                                                                                                                                                    break;
                                                                                                                                                }
                                                                                                                                              
                                                                                                                                        // Success
                                                                                                                                        default: {
                                                                                                                                          
                                                                                                                                                    this.toastFileMessage     = 'Event Successfully Registered';
                                                                                                                                                    this.toasttypeerror       = 'success';
                                                                                                                                                    this.toastVisible         = true;

                                                                                                                                                    // Close Stripe Dialogue Box
                                                                                                                                                    setTimeout( () => {
                                                                                                                                                                        this.data.closestatus = true;
                                                                                                                                                                        this.data.eventid     = this.selnewevent;
                                                                                                                                                                        this.dialogRef.close( this.data );
                                                                                                                                                      
                                                                                                                                                                      },
                                                                                                                                                                      5000
                                                                                                                                                              )

                                                                                                                                                  break;  
                                                                                                                                                }
                                                                                                                                       }

                                                                                                                                }
                                                                                                                        );
                                                                                  
                                                                                break;
                                                                              }
                                                                          //**************************************************************
                                                                      }
                                                                    
                                                                              
                                                                  }
                                                                  
                                                              }
                                                        }
                                                        //**************************************************************

                                                      )

        }
    }
  //**************************************************************
  
//**************************************************************  
  // Generate Stripe intent payment key
  async createPaymentIntent( amount: number)
    {
    
     // console.log( 'Create Stripe Payment Intent ')
     
     //const url = "http://localhost:5000/propdocsearch/us-central1/payments/" + 'intents';

    // const url = "http://localhost:4200/eventplan-58adb.cloudfunctions.net/us-central1/fsstripepaymentintent/" + 'stripeintent';

      const url = 'https://us-central1-eventplan-58adb.cloudfunctions.net/fsstripepaymentintent/'  + 'stripeintent';

      const headers = new HttpHeaders().append  (
                                                  'Content-Type',
                                                  'application/json'
                                                );

      // Body Parameters
      // Amount + Currency                                            
      const stripeobject  = { amount: amount.toString(),
                              currency: 'aud'
                            };                                          
      const body          = JSON.stringify(stripeobject);

      
      return this.http.post<any>( url, body, 
                          {
                            headers: headers
                          }
                        )
    }
  //**************************************************************  
  onConfirm(): void 
    {
      this.dialogRef.close(true);
    }
  //**************************************************************
  onDismiss(): void 
    {
      this.dialogRef.close(false);
    }
  //**************************************************************
}
